import { render, staticRenderFns } from "./HeaderPopUp.vue?vue&type=template&id=5cf4151e&scoped=true"
import script from "./HeaderPopUp.vue?vue&type=script&lang=js"
export * from "./HeaderPopUp.vue?vue&type=script&lang=js"
import style0 from "./HeaderPopUp.vue?vue&type=style&index=0&id=5cf4151e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf4151e",
  null
  
)

export default component.exports